import { inboxShowsDone, rollsOver, taskVisibleInSprint } from '@nedelnik/shared';

import type { Period, Task, TaskStatus } from '@nedelnik/shared';

/**
 * Выборки по периоду и счётчики.
 *
 * Правило показа задачи в периоде — одно на всю систему (`taskVisibleInSprint`
 * из `shared`): после смены длины спринта недельные задачи обязаны остаться
 * видимыми внутри месяца (3.2.5), и второй реализации этого правила быть не
 * должно.
 */

export function tasksInPeriod(tasks: readonly Task[], period: Period, now = new Date()): Task[] {
  return tasks.filter((task) => {
    if (!taskVisibleInSprint(task.sprint, period)) return false;
    // Во Входящих закрытое прячется через две недели (3.4.5). Правило живёт в
    // `shared`: то же самое понадобится агенту и iOS, а вторая реализация
    // разъедется с первой.
    return period !== 'inbox' || inboxShowsDone(task, now);
  });
}

/** Незакрытые: именно их считают у соседних спринтов (3.2.4) и переносят (3.11.4). */
export function openTasks(tasks: readonly Task[]): Task[] {
  return tasks.filter((task) => task.status !== 'done');
}

/**
 * Что уедет массовым переносом: незакрытые, кроме повторяющихся (3.19.3). У
 * них в следующем спринте будет свой экземпляр, а перенесённый стал бы его
 * двойником. Правило то же, что у автопереноса, — `rollsOver` из `shared`.
 */
export function carryableTasks(tasks: readonly Task[]): Task[] {
  return openTasks(tasks).filter(rollsOver);
}

export function openCountIn(tasks: readonly Task[], period: Period): number {
  return openTasks(tasksInPeriod(tasks, period)).length;
}

export type StatusCounts = Record<TaskStatus, number>;

export function countByStatus(tasks: readonly Task[]): StatusCounts {
  const counts: StatusCounts = { backlog: 0, wip: 0, done: 0 };
  for (const task of tasks) counts[task.status] += 1;
  return counts;
}
